/* MUI */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';

/*  Components  */
import { ContractBigCalendars } from './internal/ContractBigCalendars';
import { ContractUsersDetailsAppBreakdown } from './internal/ContractUsersDetailsAppBreakdown';
import { ContractsLists } from './internal/ContractsLists';
import { SummaryCard } from './internal/SummaryCard';

export const ContractsReport = ({ reportSetup, reportData }) => {
    const {
        contracts,
        numberContractsConfigured,
        totalContractValue,
        totalMonthlyValue
    } = reportData || {};

    return (
        <Box
            data-testid="contractsReportMainRender"
            data-trackid="contractsReportMainRender"
            width="100%"
            sx={{ backgroundColor: 'background.contractsReport' }}
        >
            <Box id="contractsContractsSummary">
                <SummaryCard
                    totalNumberOfContracts={numberContractsConfigured}
                    totalContractValue={totalContractValue}
                    totalMonthlyValue={totalMonthlyValue}
                />
            </Box>
            {reportSetup.reportSelections?.includes(
                'contractsContractsOverview'
            ) && (
                <Box id="contractsContractsOverview">
                    <ContractBigCalendars
                        contracts={contracts}
                        startDate={reportSetup.startTime}
                    />
                    <ContractsLists contracts={contracts} />
                </Box>
            )}
            {reportSetup.reportSelections?.includes(
                'contractsContractsApplicationUserDetails'
            ) && (
                <Box id="contractsContractsApplicationUserDetails">
                    <ContractUsersDetailsAppBreakdown contracts={contracts} />
                </Box>
            )}
        </Box>
    );
};
